export default "__VITE_ASSET__a6702b2c__"